import {ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal} from "@angular/core";
import {OrderingContextModel} from '../../ordering-context/ordering-context.model';
import {NgClass} from '@angular/common';
import {ChewzieLogoComponent} from "../chewzie-logo/chewzie-logo.component";
import {UrlPipe} from '../../utils/url.pipe';
import {CssVarDirective} from '../../utils/css-var.directive';
import {ConfigurationModel} from '../../configuration/configuration.model';

@Component({
    selector: "woa-logo",
    templateUrl: "./logo.component.html",
    styleUrl: "./logo.component.scss",
    imports: [
        ChewzieLogoComponent,
        CssVarDirective,
        NgClass,
        UrlPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    public readonly type: InputSignal<"vertical" | "horizontal"> = input.required<"vertical" | "horizontal">();

    public readonly showHorizontalLogo: Signal<boolean> = computed<boolean>(() =>
        this.configurationModel.isConsumerActor() && (this.type() === "horizontal" || !this.orderingContextModel.verticalLogoImage()));

    public readonly showVerticalLogo: Signal<boolean> = computed<boolean>(() =>
        this.configurationModel.isConsumerActor() && (this.type() === "vertical" && !!this.orderingContextModel.verticalLogoImage()));

    px(size: number) {
        return size == undefined ? undefined : size + "px";
    }
}
